import React, { useEffect, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import {
  Checkbox,
  Button,
  Menu,
  Box,
  ListItemIcon,
  IconButton,
  Typography,
} from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import FormControlLabel from "@mui/material/FormControlLabel";
import AddIcon from "@mui/icons-material/Add";
import AddResponseDialog from "./AddResponseDialog";
import Divider from "@mui/material/Divider";

const MenuProps = {
  PaperProps: {
    style: {
      width: "168px",
      height: "600px",
      border: "1.5px solid #74C69D",
      boxShadow: "8px 8px 24px rgba(16, 65, 48, 0.12)",
      borderRadius: "16px",
      marginTop: "5px",
    },
  },
};

export default function ButtonWithCheckBox({
  menuList = [],
  setMenuList = () => {},
  language = "english",
  anchorEl = null,
  handleClose = () => {},
  selectedItems = [],
  setSelectedItems = () => {},
  multiSelect = true,
  alreadyAssignedAlert = [],
  view = false,
  selectedResponseType = "dropdown",
}) {
  const open = Boolean(anchorEl);
  const [openResponseDialog, setOpenResponseDialog] = useState(false);
  const handleCloseResponseDialog = () => {
    setOpenResponseDialog(false);
  };
  const [menuListCopy, setMenuListCopy] = useState(menuList);

  const handleItemClick = (item) => {
    if (multiSelect) {
      setSelectedItems((prevSelectedItems) => {
        if (prevSelectedItems.includes(item)) {
          return prevSelectedItems.filter(
            (selectedItem) => selectedItem !== item
          );
        } else {
          return [...prevSelectedItems, item];
        }
      });
    } else {
      setSelectedItems([item]);
    }
  };

  const arrayContainsObject = (arr, obj) => {
    return arr.some((item) => item.id === obj.id && item.name === obj.name);
  };

  const handleRemoveOption = (option) => {
    setMenuListCopy((prevMenuList) =>
      prevMenuList.filter((item) => item !== option)
    );
    setMenuList((prevMenuList) => ({
      ...prevMenuList,
      [language]: prevMenuList[language].filter((item) => item !== option),
    }));
  };

  const handleSaveResponses = () => {
    setMenuList((prevMenuList) => ({
      ...prevMenuList,
      [language]: [...menuListCopy],
    }));
    handleClose();
  };

  return (
    <>
      <Menu
        PaperProps={{
          style: {
            width: "250px",
            maxHeight: "250px",
            border: "1.5px solid #74C69D",
            boxShadow: "8px 8px 24px rgba(16, 65, 48, 0.12)",
            borderRadius: "16px",
            overflowY: "auto",
          },
        }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Typography sx={{ paddingLeft: 2, paddingTop: 1, color: "#ACADAD" }}>
          {menuListCopy.length > 0 ? "Responses" : " No responses found"}
        </Typography>
        <Divider sx={{ marginBottom: 1 }} />
        {menuListCopy !== null &&
          menuListCopy.map((menu) => {
            const isDisabled = arrayContainsObject(alreadyAssignedAlert, menu);
            const isSelected = selectedItems.includes(menu);

            return (
              <MenuItem
                key={menu.id || menu.name || menu}
                value={menu.id || menu.name || menu}
                sx={{
                  color: "#2D6A4F",
                  backgroundColor: isDisabled ? "#FCECEC" : "inherit",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                  padding: "8px",
                  marginLeft: 2,
                }}
                disabled={isDisabled}
                onClick={() => handleItemClick(menu)}
              >
                <div>{menu.name || menu}</div>
                {!view && (
                  <IconButton onClick={() => handleRemoveOption(menu)}>
                    <DeleteIcon />
                  </IconButton>
                )}
                {isSelected && (
                  <ListItemIcon>
                    <DoneIcon />
                  </ListItemIcon>
                )}
              </MenuItem>
            );
          })}
        {!view && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginX: 1,
            }}
          >
            <Button
              variant="text"
              sx={{
                fontWeigh: 500,
                color: "#2D6A4F",
                backgroundColor: "#FFFFFF",
                cursor: "pointer",
                borderRadius: "20px",
                border: "1px solid var(--Primary-Green, #2D6A4F)",
                textTransform: "none",
              }}
              disabled={
                selectedResponseType.toLowerCase() === "radio" &&
                menuListCopy.length === 2
              }
              onClick={() => setOpenResponseDialog(true)}
            >
              <AddIcon sx={{ height: "22px", width: "22px" }} />
              Add Response
            </Button>

            <Button
              variant="text"
              disabled={menuListCopy.length > 1 ? false : true}
              sx={{
                fontWeigh: 500,
                color: "#2D6A4F",
                backgroundColor: "#FFFFFF",
                cursor: "pointer",
                fontSize: "16px",
                textTransform: "none",
              }}
              onClick={() => handleSaveResponses()}
            >
              Done
              <DoneIcon sx={{ height: "22px", width: "22px" }} />
            </Button>
          </Box>
        )}
      </Menu>
      {openResponseDialog && (
        <AddResponseDialog
          open={openResponseDialog}
          onClose={handleCloseResponseDialog}
          setMenuList={setMenuListCopy}
          menuList={menuListCopy}
          language={language}
        />
      )}
    </>
  );
}
